import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { OcorrenciaLogResp } from 'src/app/models/ocorrencia-log-resp';
import { OcorrenciaTipo } from 'src/app/models/ocorrencia-tipo';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { OcorrenciaTipoService } from 'src/app/services/ocorrencia-tipo.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarOcorrenciaTipoModalComponent } from '../ocorrencia-tipo-modal/cadastrar-ocorrencia-tipo-modal/cadastrar-ocorrencia-tipo-modal.component';
import { OcorrenciaLogRespService } from 'src/app/services/ocorrencia-log-resp.service';

@Component({
  selector: 'app-ocorrencia-log-resp-modal',
  templateUrl: './ocorrencia-log-resp-modal.component.html',
  styleUrls: ['./ocorrencia-log-resp-modal.component.scss']
})
export class OcorrenciaLogRespModalComponent implements OnInit {
  numeroOcorrencia: string;
  idOcorrencia: number;

  logs: OcorrenciaLogResp[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(public dialogRef: MatDialogRef<OcorrenciaLogRespModalComponent>, private carregandoService: CarregandoService, public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService, private ocorrenciaLogRespService: OcorrenciaLogRespService, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) {
    this.numeroOcorrencia = this.data.numeroOcorrencia;
    this.idOcorrencia = this.data.idOcorrencia;
  }

  ngOnInit(): void {
    this.buscarLogs();
  }

  buscarLogs() {
    this.carregandoService.mostra('buscarLogs');

    this.ocorrenciaLogRespService.consultarPorIdOcorrencia(this.idOcorrencia).subscribe((data: any) => {
      this.logs = data;
      this.carregandoService.esconde('buscarLogs');
    }, (erro) => {
      this.carregandoService.esconde('buscarLogs');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
